<template>
  <section class="log-system-index-container">
    <base-header
      v-bind="headers"
      v-on:handleLink="handleHeaderLink"
    />
    <search-header
      class="search-header"
      v-bind="searchHeader"
      :params="list.params"
      @handleSearch="handleSearchs"
      @handleBtnSearch='handleEventBtnSearch'
    ></search-header>
    <base-table
      v-bind="list"
      v-on:handleSelectionChange="handleSelectionChange"
      v-on:handleSizeChange="handleSizeChange"
      v-on:handleCurrentChange="handleCurrentChange"
      v-on:handleDelete="handleTableDelete"
    >
    </base-table>
    <msg-dialog
      v-bind="msgDialog"
      v-on:handleConfirm="handleConfirmMsg"
      v-on:handleCancel="hideMsgDialog"
    />
  </section>
</template>
<script>
import baseHeader from '@/components/mixins/baseHeader'
import baseTable from '@/components/mixins/baseTable'
import msgDialog from '@/components/mixins/msgDialog'
import searchHeader from '@/components/mixins/searchHeader'

const columns = [
  {
    prop: 'title',
    label: '标题'
  },
  {
    prop: 'createUser',
    label: '创建人'
  },
  {
    scopeType: 'time',
    prop: 'createTime',
    label: '创建时间',
    minWidth: '150px'
  }
]
export default {
  name: 'listIndex',
  mixins: [baseHeader, baseTable, searchHeader, msgDialog],
  data () {
    return {
      searchHeader: {
        searchItems: [
          {
            type: 'searchInput',
            value: 'queryTitle',
            placeholder: '请输入标题'
          }
        ]
      },
      list: {
        columns,
        api: 'fetchOabuinessRecordList',
        params: {
          queryTitle: '',
          queryCreateUser: '',
          queryStatus: '',
          queryOnlyMe: false
        },
        handleColumn: [
          {
            type: 'Link',
            name: '编辑',
            icon: 'bianji',
            notDisabled: true,
            href: '/oabusiness/record/edit'
          },
          {
            type: 'Link',
            name: '查看',
            icon: 'chakan',
            notDisabled: true,
            href: '/oabusiness/record/detail'
          },
          {
            type: 'Delete',
            name: '删除',
            icon: 'delete',
            notDisabled: true
          }
        ],
        handleColumnProp: {
          label: '操作',
          width: '300',
          align: 'left'
        },
        showSelection: false
      },
      headers: {
        buttons: [
          {
            type: 'Link',
            text: '新建',
            icon: 'xinjian',
            notDisabled: true,
            href: '/oabusiness/record/add'
          }
        ],
        title: '',
        showAlertIcon: false,
        content: ''
      }
    }
  },
  components: {
  },
  methods: {
    // 搜索
    handleSearchs () {
      var params = this.list.params
      if (params.time) {
        params.queryCreateTimeStart = params.time[0]
        params.queryCreateTimeEnd = params.time[1]
      } else {
        params.queryCreateTimeStart = ''
        params.queryCreateTimeEnd = ''
      }
      this.list.params = params
      this.fetchTableApi()
    },
    handleEventBtnSearch () {
      this.handleSearchs()
    },
    fetchTableCallBack (res) {
      if (res.code === 200) {
        this.list.data = res.data.content
        this.list.data = res.data.content.map((d, i) => {
          d.disabled = !(d.status === 'UNCHECK' || d.status === 'CHECKING' || d.status === 'CHECK_CANCEL')
          return d
        })
        this.list.totalCount = res.data.totalElements
      }
    },
    // 表格操作按钮
    handleTableDelete (row, index) {
      this.msgDialog.type = 'DeleteOne'
      this.msgDialog.content = '是否确定删除？'
      this.msgDialog.data = row.id
      this.showMsgDialog()
    },
    // 弹出框操作按钮
    handleConfirmMsg (type) {
      switch (type) {
        case 'DeleteOne':
          this.fetchOabuinessRecordDel(this.msgDialog.data)
          break
      }
    },
    fetchOabuinessRecordDel (id) {
      this.list.loading = true
      var params = {
        id: id
      }
      this.$request.fetchOabuinessRecordDel(params).then(res => {
        if (res.code === 200) {
          this.fetchTableApi()
        } else if (res.code === 14023) {}
        this.hideMsgDialog()
      }).then(this.hideTableLoading)
        .catch(this.hideTableLoading)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
